import { render, staticRenderFns } from "./clientprofile.vue?vue&type=template&id=5cbd4cae"
import script from "./clientprofile.vue?vue&type=script&lang=js"
export * from "./clientprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports